import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixImage {
  static init(...parameters) {
    return new BrixImage(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
      if (block.classList.contains('animate-me')) {
        // eslint-disable-next-line no-param-reassign
        block.style.overflow = 'hidden';
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image', BrixImage.init);
}
